This Privacy Policy applies to FoosMonster and governs data collection and usage. By using FoosMonster, you consent to the data practices described in this statement.

##### Information We Collect

FoosMonster only collects information that you voluntarily provide. When you register or use the Site, we may collect:

- **Phone Number** — used for authentication via Firebase Phone Auth
- **Player Name** — optional, displayed on tournament leaderboards
- **Game Data** — tournament names, match results, scores, teams, and player assignments that you create or participate in

We do not collect your name, email address, billing information, employer, or any other personal information.

##### How We Use Your Information

FoosMonster uses your information to:

- Authenticate your account via phone number
- Operate and display tournament brackets, match results, and player ratings
- Communicate with you about the services (e.g., SMS for account verification)

##### Analytics

FoosMonster uses Google Analytics to understand how users interact with the Site. This may include information such as pages visited, time spent, and general device/browser data. This information is anonymized and used to improve the Site.

##### Sharing Information with Third Parties

FoosMonster does not sell, rent, or lease its user data to third parties.

We share data with trusted partners who help us operate the Site, including:

- **Google (Firebase)** — for phone authentication, database hosting, and storage
- **Google Analytics** — for usage analytics

All such third parties are contractually restricted from using your personal information except to provide these services to FoosMonster.

FoosMonster may disclose your personal information if required to do so by law or in good faith belief that such action is necessary to comply with legal process, protect the rights or property of FoosMonster, or protect the personal safety of users or the public.

##### Security

FoosMonster secures your personal information using industry-standard practices, including HTTPS encryption. No data transmission over the Internet can be guaranteed 100% secure, but we strive to protect your information.

##### Children Under Thirteen

FoosMonster does not knowingly collect personal information from children under the age of thirteen. If you are under 18, you must have permission from a parent or guardian.

##### Data Retention and Deletion

FoosMonster retains your account data while your account is active. If you wish to delete your account and associated data, please contact us via Instagram DM at [@austin.foosball.club](https://instagram.com/austin.foosball.club). We will process your request within a reasonable time.

##### Changes to This Policy

FoosMonster reserves the right to change this Privacy Policy from time to time. We will notify you of significant changes by placing a prominent notice on the Site. Your continued use of the Site after such modifications constitutes your acknowledgment of the modified Policy.

##### Contact Information

FoosMonster welcomes your questions or comments regarding this Privacy Policy:

DM us on Instagram at [@austin.foosball.club](https://instagram.com/austin.foosball.club)

Effective as of August 18, 2026